import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import MaterialTable from "material-table";
import { forwardRef } from 'react';

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';

import { api_host, api_auth } from '../../../../../common/globals/constants';

import PortletContent from 'components/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment-timezone'
import 'moment/locale/es'  
moment.locale('es')

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

class ConsolidatedMeasurements extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            step: null,
            hoverData: null,
            lastEvent: [],
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            rows: null,
            noMonCum: null,
            downCum: null,
            date: this.props.params.date,
            dateMoment: ((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")),
            isRefresh: this.props.params.isRefresh,
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        /*if (props.match.params.objetivo_id !== state.prevObjectiveId) {
            return {
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
            }
        } else if (props.params.period !== state.time) {
            return {
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        } else if (props.params.step !== state.step) {
            return {
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: state.time,
                step: props.params.step,
                lastEvent: [],
                dataError: false,
                isLoading: true,
                hoverData: null,
                statePeriod: props.params.statePeriod
            }
        } else if(props.params.isRefresh !== state.isRefresh){
            return {
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isRefresh: props.params.isRefresh,          
            }

        } else if ((props.params.period === state.time) && (props.params.statePeriod !== state.statePeriod)) {
            return {
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                hoverData: null,
                isLoading: true,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        }*/
        if (nextProps.params.period !== prevState.time) {
            
            return {
                externalData: null,
                //prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                rows: null,
                statePeriod: nextProps.params.statePeriod,
                //isStatePeriod: nextProps.params.isStatePeriod
            }
        } else if(nextProps.params.isRefresh !== prevState.isRefresh){
            return {
                externalData: null,
                //prevObjectiveId: props.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                rows: null,
                statePeriod: nextProps.params.statePeriod,
                isRefresh: nextProps.params.isRefresh,          
            }

        } else if ((nextProps.params.period === prevState.time) && (nextProps.params.statePeriod !== prevState.statePeriod)) {
            return {
                //prevObjectiveId: props.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                hoverData: null,
                isLoading: true,
                lastEvent: [],
                rows: null,
                statePeriod: nextProps.params.statePeriod,
                isStatePeriod: nextProps.params.isStatePeriod
            }
        }
        return null;
    }


    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if((prevProps.params.isRefresh !== this.state.isRefresh) && this.state.dateMoment!==((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))){
            this.props.params.onDateMoment(((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")))
        }

        /*if ((prevProps.params.period !== this.state.time) ||
            (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) ||
            (prevProps.params.step !== this.state.step) ||
            (prevProps.params.isRefresh !== this.state.isRefresh) ||
            (prevProps.params.statePeriod !== this.state.statePeriod)) {
            this.getDataFromAPI();
        }*/

        if ((prevProps.params.period !== this.state.time) ||
            (prevProps.params.isRefresh !== this.state.isRefresh) ||
            (prevProps.params.statePeriod !== this.state.statePeriod)) {                
            this.getDataFromAPI();
        }

    }
    componentWillUnmount() {

    }

    getDataFromAPI = (objectiveId) => {
        const { objetivo_id } = this.props.match.params
        const { fromObjective } = this.props.location.state
        const { period, statePeriod, step, isStepDowntime } = this.props.params
        const { history } = this.props;
        //const {period, statePeriod} = this.props

        let sla_rendimiento_ok = parseInt(fromObjective.sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(fromObjective.sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(fromObjective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(fromObjective.sla_disponibilidad_error)
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        let time = 'w'
        //let stepLocal = step
        let node = 0
        if (this.state.period !== 'w') {
            time = 'd'
        }
        /*if (isStepDowntime) {
            stepLocal = -1
        }*/
        if (period === 'c') {
            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10)
            fecha_termino = statePeriod.endDate.toISOString().substring(0, 10)
            // console.log("fecha_inicio",fecha_inicio , "    ", "fecha_termino",fecha_termino)
            Promise.all([
                    fetch(api_host + `/reporte/online/indicadores/getResumenDisponibilidadParcialObjetivoCustom/?objetivoId=${objetivo_id}&horarioId=0&token=${token}&key=${api_auth}&fechaInicio=${fecha_inicio}&fechaTermino=${fecha_termino}&nodoId=${node}`),
                    fetch(api_host + `/reporte/online/indicadores/getResumenRendimientoParcialObjetivoCustom/?objetivoId=${objetivo_id}&horarioId=0&token=${token}&key=${api_auth}&fechaInicio=${fecha_inicio}&fechaTermino=${fecha_termino}&nodoId=${node}`),
                    fetch(api_host + `/reporte/online/indicadores/getTotalMedicionesParcialCustom/?key=${api_auth}&objetivoId=${objetivo_id}&fechaInicio=${fecha_inicio}&fechaTermino=${fecha_termino}&token=${token}&horarioId=0`)
                ])
                .then(([res1, res2, res3]) => {
                    return Promise.all([res1.json(), res2.json(), res3.json()])
                })
                .then(([res1, res2, res3]) => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (res1.status == 1 || res1.status == 5 || res2.status == 1 || res2.status == 5 || res3.status == 1 || res3.status == 5) {
                        localStorage.setItem('isAuthenticated', false);                        
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(res1, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                'step',
                                period,
                                fecha_inicio,
                                fecha_termino, res2, res3)
                            if (this.state.lastEvent !== []) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {
                            console.log(error)
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }
                });
        } else {
            Promise.all([
                    fetch(api_host + `/reporte/online/indicadores/getResumenDisponibilidadParcialObjetivo/?objetivoId=${objetivo_id}&horarioId=0&token=${token}&key=${api_auth}&t=${period}&nodoId=${node}`),
                    fetch(api_host + `/reporte/online/indicadores/getResumenRendimientoParcialObjetivo/?objetivoId=${objetivo_id}&horarioId=0&token=${token}&key=${api_auth}&t=${period}&nodoId=${node}`),
                    fetch(api_host + `/reporte/online/indicadores/getTotalMedicionesParcial/?key=${api_auth}&objetivoId=${objetivo_id}&t=${period}&token=${token}&horarioId=0`)
                ])
                .then(([res1, res2, res3]) => {
                    return Promise.all([res1.json(), res2.json(), res3.json()])
                })
                .then(([res1, res2, res3]) => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (res1.status == 1 || res1.status == 5 || res2.status == 1 || res2.status == 5 || res3.status == 1 || res3.status == 5) {
                        localStorage.setItem('isAuthenticated', false);                        
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(res1, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                'step',
                                period,
                                fecha_inicio,
                                fecha_termino, res2, res3)
                        } catch (error) {
                            console.log(error)
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }

                });

        }
    }

    // Helper para procesar la data de la petición a la API

    processData = (dataDisponibility,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        step,
        period,
        fecha_inicio,
        fecha_termino, dataResponse, dataMeasurements) => {

            let stepsDisponibility = dataDisponibility.Objetivo.Paso
            let stepsResponse = dataResponse.Objetivo.Paso
            let measures = dataMeasurements.mediciones
            let arrayRows = []
            var stepCount = 0
            Object.keys(measures).map((key0)=> {

                stepCount = measures[key0].cantidad_pasos
                Object.keys(stepsDisponibility).map((key1)=>{
                    let rows = {}
                    rows['monitor'] = measures[key0].nombre
                    if(typeof(stepCount) ==="undefined" ){
                        rows['total'] = measures[key0].mediciones
                    }else{
                        rows['total'] = measures[key0].mediciones  / stepCount
                    }
                    rows['paso'] = stepsDisponibility[key1].paso_nombre
                    
                    Object.keys(stepsDisponibility[key1].estado).map((key2)=>{
                        let noMonCum = 0
                        let downCum = 0
                        let upCum = 0
                        
                        if (stepsDisponibility[key1].estado[key2].nodo_id == measures[key0].nodo_id){                             
                            
                            Object.keys(stepsDisponibility[key1].estado[key2].estado).map((key3)=>{
                                
                                if (stepsDisponibility[key1].estado[key2].estado[key3].nombre == 'uptime'){
                                    upCum = upCum + stepsDisponibility[key1].estado[key2].estado[key3].porcentaje
                                }
                                if (stepsDisponibility[key1].estado[key2].estado[key3].nombre == 'downtime'){
                                    downCum = downCum + stepsDisponibility[key1].estado[key2].estado[key3].porcentaje
                                }
                                if (stepsDisponibility[key1].estado[key2].estado[key3].nombre == 'sin información'){
                                    noMonCum = noMonCum + stepsDisponibility[key1].estado[key2].estado[key3].porcentaje
                                }  
                                if (stepsDisponibility[key1].estado[key2].estado[key3].nombre == 'no monitoreo'){
                                    noMonCum = noMonCum + stepsDisponibility[key1].estado[key2].estado[key3].porcentaje
                                }                              
                            })
                            rows['uptime'] = upCum
                            rows['downtime'] = downCum
                            rows['nomon'] = noMonCum
                        }
                    })
                    Object.keys(stepsResponse).map((key)=>{                        
                        
                        if (stepsResponse[key].paso_id == stepsDisponibility[key1].paso_id) {
                        
                            Object.keys(stepsResponse[key].nodos).map((key2)=>{
                                
                                if (stepsResponse[key].nodos[key2].nodo_id == measures[key0].nodo_id){
                                    rows['minimo'] = stepsResponse[key].nodos[key2].rendimiento.tiempo_minimo
                                    rows['maximo'] = stepsResponse[key].nodos[key2].rendimiento.tiempo_maximo
                                    rows['promedio'] = stepsResponse[key].nodos[key2].rendimiento.tiempo_promedio
                                }
                            })
                        }
                    })
                    if (rows['minimo'] == null){
                        rows['minimo'] = 's/i'
                    }
                    if (rows['maximo'] == null){
                        rows['maximo'] = 's/i'
                    }
                    if (rows['promedio'] == null){
                        rows['promedio'] = 's/i'
                    }
                    if (rows['uptime'] == null){
                        rows['uptime'] = 's/i'
                    }
                    if (rows['downtime'] == null){
                        rows['downtime'] = 's/i'
                    }
                    if (rows['nomon'] == null){
                        rows['nomon'] = 's/i'
                    }
                    if (rows['total'] == null){
                        rows['total'] = 's/i'
                    }
                    arrayRows.push(rows)
                })                
            })           
            this.setState({
                rows : arrayRows,
                //noMonCum : noMonCumDate,
                //downCum : downCumDate,
                isLoading: false,
                //time: period,
                //step: step,
                dataError: false,
            }); 
       
    }

    render() {
        const { dataError, isLoading, rows, noMonCum, downCum } = this.state;
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };       
        

        if (!dataError) {
            if (sessionStorage.getItem('nameMeasurements').length == 4) { 
                var periodMeasurements = 'Rango: último día'
            }else if (sessionStorage.getItem('nameMeasurements')!= undefined || sessionStorage.getItem('nameMeasurements') != null){ 
                var periodMeasurements = sessionStorage.getItem('nameMeasurements')
            }
            
            sessionStorage.setItem("tableMedicionISP",JSON.stringify({'header':[{'monitor':"Monitor"},{'paso':"Paso"},{'minimo':"Minimo (seg)"},{'maximo':"Maximo (seg)"},
                                                                    {'promedio':"Promedio (seg)"},{'uptime':"Uptime (%)"},{'downtime':"Downtime (%)"},{'nomon':"Sin Mon. (%)"},
                                                                    {'total':"Total Mon."}],'data':rows,'title':'Consolidación de Mediciones por ISP','subtitle':periodMeasurements}))
            
            return (<FormattedChart rows={rows} noMonCum={noMonCum} downCum={downCum} isLoading={isLoading} style={style} styleHidden={styleHidden} />) 
        }
        else if (dataError) {
            return (<p>No hay datos..</p>)
        }
        else return (<p> Error!</p >)

    }
}

function FormattedChart(props) {
    
    return (
        <div>
            { props.rows == null  ? 
                <PortletContent>
                    <PerfectScrollbar>

                        <Typography
                        variant="h5"
                        >
                        <CircularProgress
                        variant="indeterminate"

                        size={24}
                        thickness={4}
                        
                        />
                        <br/>
                        Cargando Información...
                    </Typography>
                    </PerfectScrollbar>
                </PortletContent>
            :
                <div style={{ maxWidth: "100%", backgroundColor:"#656565" }}>
                    <MaterialTable
                        //style={{backgroundColor:"#656565"}}
                        icons={tableIcons}
                        columns={[
                            { title: "Monitor", field: "monitor", defaultGroupOrder: 0 },
                            { title: "Paso", field: "paso" },
                            { title: "Minimo (seg)", field: "minimo"/*, type: "numeric"*/ },
                            { title: "Máximo (seg)", field: "maximo"/*, type: "numeric"*/},
                            { title: "Promedio (seg)", field: "promedio"/*, type: "numeric"*/},
                            { title: "Uptime (%)", field: "uptime"/*, type: "numeric"*/ },
                            { title: "Downtime (%)", field: "downtime"/*, type: "numeric"*/},
                            { title: "Sin Mon. (%)", field: "nomon"/*, type: "numeric"*/}, 
                            { title: "Total Mon.", field: "total"/*, type: "numeric"*/}, 
                        ]}
                        /*data={[
                            { monitor: "Claro (cl)", paso: "Home", minimo: 0.320, maximo: 22.700, promedio: 2.590, uptime: 100.000, downtime: 0.000, nomon: 0.000, total: 213  },
                            { monitor: "Claro (cl)", paso: "Login", minimo: 0.320, maximo: 22.700, promedio: 2.590, uptime: 100.000, downtime: 0.000, nomon: 0.000, total: 213  },
                            { monitor: "Claro (cl)", paso: "Liquidaciones", minimo: 0.320, maximo: 22.700, promedio: 2.590, uptime: 100.000, downtime: 0.000, nomon: 0.000, total: 213  },
                            { monitor: "Entel (cl)", paso: "Home", minimo: 0.280, maximo: 4.580, promedio: 2.470, uptime: 99.530, downtime: 0.470, nomon: 0.000, total: 213  }
                        ]}*/
                        data={props.rows} 
                        title=" "
                        localization={{
                            grouping: {
                                groupedBy: 'Agrupar por:',
                                placeholder: 'Arrastre los encabezados aquí, para agrupar',
                            },
                            body: {
                                emptyDataSourceMessage: 'No hay datos'
                            },
                            toolbar: {
                                searchTooltip: 'Buscar',
                                searchPlaceholder: 'Buscar'
                            },
                            pagination: {
                                labelRowsSelect: 'Filas',
                                labelDisplayedRows: ' {from}-{to} de {count}',
                                firstTooltip: 'Pri. pág.',
                                previousTooltip: 'Pág. previa',
                                nextTooltip: 'Sig. pág.',
                                lastTooltip: 'Últ. pág'
                            }
                        }}
                        options={{
                            grouping: true
                        }}
                    />
                </div>}
            </div>
        )

}


export default withRouter(ConsolidatedMeasurements);